<template>
  <div>
    <BaseFetchData :action="fetchApprovalRequests" :lazy="loadOnMounted === false">
      <ApprovalRequestList
        :project-asset="projectAsset"
        :approval-requests="approvalRequests"
        :load-list="fetchApprovalRequests"
        @approval-request-list-changed="$emit('approval-request-manager-changed')"
      />
    </BaseFetchData>
  </div>
</template>

<script>
import { projectAssetApprovalRequestsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import ApprovalRequestList from './ApprovalRequestManager/ApprovalRequestList.vue';

export default {
  components: { ApprovalRequestList },
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      approvalRequests: [],
    };
  },
  computed: {
    loadOnMounted() {
      if (typeof this.projectAsset?.approvalRequests !== 'number') {
        return true;
      }

      return this.projectAsset.approvalRequestsCount > 0;
    },
  },
  methods: {
    async fetchApprovalRequests() {
      try {
        const response = await projectAssetApprovalRequestsClient.list(this.projectAsset.id, {
          include: ['user', 'comments'],
        });

        this.approvalRequests = mapKeysToCamelCase(response.data, true);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
